import './index.css'
import PricingModule from '../pricing-module';
import PricingModulePayment from '../pricing-module-payment';

function PricingHolder({subscription,details}){
    if(!subscription){
    return <>
    <h1 className='big-text' id='pricing-title'>Pricing</h1>
    <div id='pricing-holder'>
    <PricingModule price='$5.99' interval='Monthly' CTA='Get started' />
    <PricingModule price='$50' interval='Yearly' CTA='Get started'/>
    </div>
    </>
    }
    if(subscription){
        return <>
        <div id='pricing-holder'>
        <PricingModulePayment price='$5.99' interval='Monthly' CTA='Subscribe' details={details} />
        <PricingModulePayment price='$50' interval='Yearly' CTA='Subscribe' details={details}/>
        </div>
        </> 
    }
}

export default PricingHolder